import { createServiceToken } from '@/app/di';
import type { IAuthPort } from './domain/ports/auth.port';

export const AUTH_SERVICE = createServiceToken<IAuthPort>('AuthService');
